import {
  fetchPsmsIndicatorError,
  fetchPsmsIndicatorSuccess,
} from '@src/middleware/actions/psms/psmsActions';
import type { PSMSIndicatorApiResponse } from '@src/middleware/services/psms/psmsIndicator.service';
import { getProviderMetricsIds } from '@src/middleware/services/psms/psmsIndicator.service';
import { call, put } from 'redux-saga/effects';

export function* fetchPsmsIndicator() {
  try {
    const response: PSMSIndicatorApiResponse | null = yield call(
      getProviderMetricsIds
    );
    if (response) {
      yield put(fetchPsmsIndicatorSuccess(response));
    }
  } catch (error) {
    yield put(fetchPsmsIndicatorError(error));
  }
}

export default fetchPsmsIndicator;
